import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=4b8e634a&scoped=true&"
import script from "./TeamCreate.vue?vue&type=script&lang=js&"
export * from "./TeamCreate.vue?vue&type=script&lang=js&"
import style0 from "./TeamCreate.vue?vue&type=style&index=0&id=4b8e634a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e634a",
  null
  
)

component.options.__file = "TeamCreate.vue"
export default component.exports